import { useMemo } from 'react';
import '../../internals/89afd3114d9c158f62e0e21a82cf39c4eddcf7acec690559797227aa316f9264.cfe-internal.js';
import { useDragDropManager } from '../2c2a08c7de500853fb7e7fc6c23b7488305aacbb55475e14a20fb57649979a77.cfe-internal.js';
import { DragSourceMonitorImpl } from '../../internals/9da24c05d59af8a126706565d1609deb696078769b9e5d069dcd5c74fa951d13.cfe-internal.js';

function useDragSourceMonitor() {
  var manager = useDragDropManager();
  return useMemo(function () {
    return new DragSourceMonitorImpl(manager);
  }, [manager]);
}

export { useDragSourceMonitor };
